module.controller('expandedCtrl', ['$scope', '$state', '$rootScope', '$http', '$filter', 'Session', 'TransactionService', 'baseURI', 'Transform', '$stateParams', 'accountService', '$window', function ($scope, $state, $rootScope, $http, $filter, Session, TransactionService, baseURI, Transform, $stateParams, accountService, $window){
  var subUrl = baseURI + 'card/sub-cards';
  var ssoUrl = baseURI + 'oauth/ssotoken';
  var printViewParams = {};
  var section;

  $scope.sort = '-Time';

  $scope.transactions = [];
  $scope.loading = false;
  $scope.loadingSubs = false;
  $scope.canOpen = true;

  $scope.filterList = false;
  $scope.calendarList = false;
  $scope.cardList = false;

  $scope.query = {};

  var defaultDateRange = {
    startDate: moment().subtract(29, 'days'),
    endDate: moment()
  };

  $scope.datePicker = {
    date: defaultDateRange,
    min: "2015-01-01",
    max: moment(),
    options: {
      cancelOnOutsideClick: false,
      locale: {
        separator: ' - ',
        format: 'MM/DD/YYYY',
      },
      ranges: {
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'Last 90 Days': [moment().subtract(89, 'days'), moment()],
        'Last 6 Months': [moment().subtract(6, 'months'), moment()],
        'Last 12 Months': [moment().subtract(12, 'months'), moment()],
        'Last 18 Months': [moment().subtract(18, 'months'), moment()],
        'Last 24 Months': [moment().subtract(24, 'months'), moment()]
      },
      eventHandlers: {
        'apply.daterangepicker': function(event, picker) {
          updateFeed();
        },
        'hide.daterangepicker': function(event, picker) {
          updateFeed();
        },
      }
    }
  };

  $scope.query.selectedFilterList = 'All transactions';
  $scope.query.selectedCardList = 'Your card';

  $scope.primary = {
    Username: Session.getUsername()
  };

  $scope.accounts = accountService.getAccounts();

  $scope.goBack = function(){
    $window.history.back();
  };

  $scope.print = function(){
    var printViewUrl = $state.href('printFeed');
    printViewUrl = printViewUrl + '?' + Transform.encode(printViewParams);
    window.open(printViewUrl, '_blank');
  };

  $scope.downloadCsv = function(){
    var fromDate = $scope.datePicker.date.startDate.format('YYYY-MM-DD');
    var toDate = $scope.datePicker.date.endDate.format('YYYY-MM-DD');

    var queryUrl = baseURI + 'transactions/by-date/' + section + '/' + fromDate + '/' + toDate;
    queryUrl = queryUrl + '/?Username=' + $scope.query.selectedCardList.username + '&csv=true';

    $http.get(queryUrl).then(function (resp){
      var hiddenElement = document.createElement('a');
      hiddenElement.href = resp.data.Data;
      hiddenElement.target = '_blank';
      hiddenElement.download = 'transactions' + fromDate + '-' + toDate + '.csv';

      setTimeout(function(){ hiddenElement.click(); }, 1500);
    });
  };

  $scope.reset = function(){
    $scope.query.selectedFilterList = 'All transactions';

    accountService.initializeAccounts(function(err, accounts){
      if(!err){
        $scope.query.selectedCardList = accountService.getAccount($stateParams.username);

        $scope.filterList = false;
        $scope.calendarList = false;
        $scope.cardList = false;

        $scope.sort = '-Time';

        updateFeed();
      }
    });
  };

  $scope.openDrawer = function(drawer){
    switch(drawer){
    case 'filterList':
      $scope.filterList = true;
      $scope.calendarList = false;
      $scope.cardList = false;
      break;
    case 'calendarList':
      $scope.filterList = false;
      $scope.calendarList = true;
      $scope.cardList = false;
      break;
    case 'cardList':
      $scope.filterList = false;
      $scope.calendarList = false;
      $scope.cardList = true;
      break;
    }
  };

  $scope.closeDrawer = function(drawer){
    $scope[drawer] = false;
  };

  $scope.selectFilterList = function(selected){
    $scope.filterList = false;
    $scope.query.selectedFilterList = selected;
    $scope.closeDrawer('filterList');
    updateFeed();
  };

  $scope.selectCalendarList = function(selected){
    $scope.calendarList = false;
    $scope.closeDrawer('calendarList');
    updateFeed();
  };

  $scope.selectCardList = function(selected){
    $scope.cardList = false;
    $scope.query.selectedCardList = selected;
    $scope.closeDrawer('cardList');

    $state.go('member.home.expanded', {username: selected.username});
  };

  var updateFeed = function(){
    $scope.loading = true;
    var queryUrl;

    switch($scope.query.selectedFilterList){
    case 'All transactions':
      section = 'all';
      break;
    case 'Network':
      section = 'transfer';
      break;
    case 'Loads':
      section = 'load';
      break;
    case 'Withdrawals':
      section = 'withdraw';
      break;
    }

    // if date ended up invalid, set to default
    if (!$scope.datePicker.date) {
      $scope.datePicker.date = defaultDateRange;
    }

    var fromDate = $scope.datePicker.date.startDate.format('YYYY-MM-DD');
    var toDate = $scope.datePicker.date.endDate.format('YYYY-MM-DD');

    printViewParams.Section = section;
    printViewParams.FromDate = fromDate;
    printViewParams.ToDate = toDate;
    printViewParams.Count = '100';


    queryUrl = baseURI + 'transactions/by-date/' + section + '/' + fromDate + '/' + toDate;
    queryUrl = queryUrl + '/?Username=' + $scope.query.selectedCardList.username;

    printViewParams.Username = $scope.query.selectedCardList.username;

    // Caching this url for print view
    $http.get(queryUrl, {cache: true}).then(function(resp){
      $scope.transactions = transformFeed(resp.data.Data.Transactions).transactions;
    }).then(function(){
      $scope.loading = false;
    });
  };

  var transformFeed = function(feed){
    var akimboFeed = {};
    var notifications = [];
    var transactions = [];

    for(var f in feed){
      if(feed[f].IsNotification){
        feed[f].Id = f;
        notifications.push(feed[f]);
      } else {
        transactions.push(feed[f]);
      }
    }

    //akimboFeed.notifications = formatNotifications(notifications);
    akimboFeed.transactions = formatTransactions(transactions);

    return akimboFeed;
  };


  var formatTransactions = function(transactions){
    var balance = $scope.query.selectedCardList.balance;

    for(var t in transactions){
      // set index balance to current balance
      if(t === '0'){
        transactions[t].Balance = balance;
      } else {
        balance = balance - transactions[t - 1].Amount;
        transactions[t].Balance = balance;
      }
      transactions[t].FormattedDate = moment(transactions[t].Time).format('h:mma MMMM Do, YYYY');
    }
    return transactions;
  };

  $scope.reset();
}]);
